import { displayNewApplicationForm } from "../services/new-application-form-service";
import $ from "jquery";


document.addEventListener('DOMContentLoaded', function () {
  toggleMenu();
  displayNewApplicationForm();
  allCustomChoices();

  /**
   * Add class to html tag when scroll is greater than 115px
   */
  window.addEventListener('scroll', function () {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var mobileLogo = document.getElementById('mobile-logo')

    if (scrollTop > 115) {
      document.documentElement.classList.add('menu-sticky');
      mobileLogo.classList.add('flex-mobile');
    } else {
      document.documentElement.classList.remove('menu-sticky');
      mobileLogo.classList.remove('flex-mobile');
    }
  });

}, false);

function toggleMenu() {
  const menu = document.getElementById('mobile-menu')
  if (undefined != menu) {
    const hamburguer = menu.getElementsByClassName('hamburguer')[0]
    const menuContainer = menu.getElementsByClassName('items-container')[0]
    hamburguer.onclick = () => {
      const html = document.querySelector('html');
      html.classList.toggle('menu-open');
      hamburguer.classList.toggle('closed')
      menuContainer.classList.toggle('open')
    }
  }
}

/**
 * Use this function to initialize all custom choices selectors
 * The form must have the class 'custom-choices' in order to the css works
 * The select tag must have the attribute 'custom-choices__select' in order to this js works
 */
const allCustomChoices = () => {
  const allCustomSelectors = document.querySelectorAll('.custom-choices__select, .custom-choices__select select');
  if (allCustomSelectors?.length > 0) {
    allCustomSelectors.forEach(theSelector => {
      if (theSelector instanceof HTMLInputElement || theSelector instanceof HTMLSelectElement) {
        const selector = new Choices(theSelector, {
          shouldSort: false,
          position: "bottom",
        });
      }
    });
  }
}

/**
 * Use this function to initialize any slider only on mobile
 */
export const mobileSlider = (elem, paginationElement) => {
  let swiper;
  let init = false;

  let mobile = window.matchMedia("(min-width: 0px) and (max-width: 591px)");
  let desktop = window.matchMedia("(min-width: 592px)");

  swiper = new Swiper(`${elem}`, {
    slidesPerView: 1.5,
    centeredSlides: true,
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: paginationElement,
      clickable: true,
    },
    breakpoints: {
      591: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });

  if (mobile.matches) {
    if (!init) {
      init = true;
      swiper.init();
    }
  }
  // Disable (for desktop)
  else if (desktop.matches) {
    swiper.destroy(false, true);
    init = false;
  }
};

$('#show-password').on('click', function () {

  if ($('#show-password').hasClass('fa-eye')) {
    $('#user_pass0').prop('type', 'text')
    $('#show-password').removeClass('fa-eye')
    $('#show-password').addClass('fa-eye-slash')
  } else {
    $('#user_pass0').prop('type', 'password')
    $('#show-password').removeClass('fa-eye-slash')
    $('#show-password').addClass('fa-eye')
  }
})